package com.arena_web.data.repository

import com.arena_web.data.api.TeamApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.TeamRepository

class TeamRepositoryImpl(private val teamApi: TeamApi) : TeamRepository {

    override suspend fun createTeam(request: CreateTeamRequest): Result<TeamWithMembersDto> =
        apiCall { teamApi.createTeam(request) }

    override suspend fun getMyTeams(): Result<List<TeamDto>> =
        apiCall { teamApi.getMyTeams() }

    override suspend fun getTeam(teamId: String): Result<TeamWithMembersDto> =
        apiCall { teamApi.getTeam(teamId) }

    override suspend fun updateTeam(teamId: String, request: UpdateTeamRequest): Result<TeamWithMembersDto> =
        apiCall { teamApi.updateTeam(teamId, request) }

    override suspend fun deleteTeam(teamId: String): Result<Unit> =
        apiCallUnit { teamApi.deleteTeam(teamId) }

    override suspend fun addMember(teamId: String, request: AddTeamMemberRequest): Result<Unit> =
        apiCallUnit { teamApi.addMember(teamId, request) }

    override suspend fun removeMember(teamId: String, userId: String): Result<Unit> =
        apiCallUnit { teamApi.removeMember(teamId, userId) }

    override suspend fun updateMemberRoles(teamId: String, userId: String, request: UpdateTeamMemberRolesRequest): Result<Unit> =
        apiCallUnit { teamApi.updateMemberRoles(teamId, userId, request) }

    override suspend fun getMatches(teamId: String): Result<List<TeamMatchDto>> =
        apiCall { teamApi.getMatches(teamId) }

    override suspend fun getChart(teamId: String, params: Map<String, String>): Result<StatsChartDto> =
        apiCall { teamApi.getChart(teamId, params) }

    override suspend fun searchTeams(query: String, sportId: String?): Result<List<TeamDto>> =
        apiCall { teamApi.searchTeams(query, sportId) }
}
